import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmpowermentBanner.css';

/**
 * EmpowermentBanner - Full-width image with text overlay
 *
 * Features:
 * - Full-width image with proper aspect ratio
 * - Text overlay with gradient for readability
 * - Uses team-collaboration-meeting.png showing diverse women working together
 * - Empowering message with links to forced arbitration and NDA definitions
 */
export function EmpowermentBanner() {
  const { t } = useTranslation();

  return (
    <section className="empowerment-banner">
      <div className="empowerment-image-container">
        <img
          src="/story_images/power.png"
          alt={t('empowermentBanner.imageAlt')}
          className="empowerment-image"
          draggable="false"
        />
        <div className="empowerment-overlay"></div>
        <div className="empowerment-text-content">
          <h2 className="empowerment-heading">{t('empowermentBanner.heading')}</h2>
          <p className="empowerment-subheading">
            {t('empowermentBanner.descriptionIntro')}{' '}
            {t('empowermentBanner.descriptionStart')}{' '}
            <a
              href="https://liftourvoices.org/s/LOV-Forced-Arbitration-One-Pager.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="empowerment-link"
            >
              {t('empowermentBanner.forcedArbitration')}
            </a>
            {' '}{t('empowermentBanner.or')}{' '}
            <a
              href="https://liftourvoices.org/definitions"
              target="_blank"
              rel="noopener noreferrer"
              className="empowerment-link"
            >
              {t('empowermentBanner.ndas')}
            </a>
            {t('empowermentBanner.descriptionEnd')}
          </p>
        </div>
        <div className="empowerment-tagline">
          {t('empowermentBanner.tagline')}
        </div>
      </div>
    </section>
  );
}
